import configs from 'configs'
import { localStore } from 'utils/store'

const realEstatesApi = ({ apiClient }) => ({
  show(id, params = {}, configs = {}) {
    return apiClient.get(`real-estates/${id}`, params, configs)
  },

  update(id, data, configs = {}) {
    return apiClient.put(`real-estates/${id}`, data, configs)
  },

  async subscription() {
    const reId = localStore.get(configs.OPERATOR_KEY).real_estate_id
    const {
      data: { subscription },
    } = await apiClient.get(`real-estates/${reId}`)
    return subscription
  },

  async warnings() {
    const reId = localStore.get(configs.OPERATOR_KEY).real_estate_id
    const {
      data: { subscription_warnings },
    } = await apiClient.get(`real-estates/${reId}`)
    return subscription_warnings
  },

  getTheme(params = {}) {
    return apiClient.get('real-estates/theme-config', { params });
  },

  updateTheme(payload) {
    return apiClient.post('real-estates/theme-config/menu/', payload);
  },

  showCustomSpot(params = {}) {
    return apiClient.get('real-estates/theme-config/custom-spot', { params });
  },

  updateCustomSpot(payload) {
    return apiClient.post('real-estates/theme-config/custom-spot', payload);
  },

  showPopupConfig(params = {}) {
    return apiClient.get('real-estates/theme-config/popup', { params });
  },

  updatePopupConfig(payload) {
    return apiClient.post('real-estates/theme-config/popup', payload);
  },

  showBlogConfig(params = {}) {
    return apiClient.get('real-estates/theme-config/blog', { params });
  },

  updateBlogConfig(payload) {
    return apiClient.post('real-estates/theme-config/blog', payload);
  },

})

export default realEstatesApi
